export const INDIA_ISO = 'IN';
export const STATE_NOT_APPLICABLE = 'Not Applicable';
export const CITY_OTHER = 'Other';

let cscPromise = null;

const getCSC = () => {
  if (!cscPromise) {
    cscPromise = import('country-state-city');
  }
  return cscPromise;
};

export const getAllCountries = async () => {
  const { Country } = await getCSC();
  return Country.getAllCountries()
    .map(({ name, isoCode }) => ({ name, isoCode }))
    .sort((a, b) => a.name.localeCompare(b.name));
};

export const getCountryIsoCode = async (countryName) => {
  if (!countryName) return '';
  const { Country } = await getCSC();
  return Country.getAllCountries().find((c) => c.name === countryName)?.isoCode || '';
};

export const isIndia = (countryName) => countryName === 'India';

export const getIndianStatesAndUTs = async () => {
  const { State } = await getCSC();
  return State.getStatesOfCountry(INDIA_ISO)
    .map(({ name, isoCode }) => ({ name, isoCode }))
    .sort((a, b) => a.name.localeCompare(b.name));
};

export const getStateIsoCode = async (countryIsoCode, stateName) => {
  if (!countryIsoCode || !stateName) return '';
  const { State } = await getCSC();
  return State.getStatesOfCountry(countryIsoCode).find((s) => s.name === stateName)?.isoCode || '';
};

export const getCitiesForLocation = async (countryName, stateName) => {
  if (!countryName) return [];

  const { Country, State, City } = await getCSC();
  const countryIsoCode = Country.getAllCountries().find((c) => c.name === countryName)?.isoCode;

  if (!countryIsoCode) return [];

  let cities = [];

  if (isIndia(countryName)) {
    const stateIsoCode = State.getStatesOfCountry(countryIsoCode).find(
      (s) => s.name === stateName
    )?.isoCode;
    if (!stateIsoCode) return [];
    cities = City.getCitiesOfState(countryIsoCode, stateIsoCode);
  } else {
    cities = City.getCitiesOfCountry(countryIsoCode);
  }

  const cityNames = [...new Set(cities.map((c) => c.name))].sort((a, b) =>
    a.localeCompare(b)
  );
  cityNames.push(CITY_OTHER);
  return cityNames;
};

export const getResolvedCityValue = (city, otherCity) => {
  if (city === CITY_OTHER) {
    return otherCity?.trim() || '';
  }
  return city?.trim() || '';
};

export const isCitySelectionReady = (countryName, stateName) => {
  if (!countryName) return false;
  if (isIndia(countryName)) return Boolean(stateName);
  return true;
};